import Vue from 'vue';
import * as Vuex from 'vuex';
import { createStore, Module } from 'vuex-smart-module';
import GlobalModule from '@/shared/store';
import AuthModule from '@/modules/auth/store';
import UserModule from '@/modules/user/store';
import OrganizationsModule from '@/modules/organizations/store';
import OrganizationsSharedModule from '@/modules/organizations/shared/store';
import ClientsModule from '@/modules/clients/store';
import ClientsSharedModule from '@/modules/clients/shared/store';
import CartModule from '@/modules/cart/store';
import CartSharedModule from '@/modules/cart/shared/store';
import ProductsModule from '@/modules/products/store';
import OrdersModule from '@/modules/orders/store';
import StaffsModule from '@/modules/staffs/store';
import LeadsModule from '@/modules/leads/store';
import VideosModule from '@/modules/videos/store';
import SubpartnersModule from '@/modules/subpartners/store';
import CompaniesUsersModule from '@/modules/companies-users/store';
import RepairsStore from '@/modules/repairs/store';
import DispatchesStore from '@/modules/dispatches/store';
import NotificationsStore from '@/modules/notifications/store';
import LastNotificationsStore from '@/components/notifications-sidebar/store';
import WidgetsStore from '@/components/widgets/store';
import MarketingFund from '@/modules/marketing-fund/store';
import Reports from '@/modules/reports/store';
import ProjectsStore from '@/modules/projects/store';
import BrandsStore from '@/modules/brand-portal/store';
import CoursesRequestsStore from '@/modules/courses-requests/store';
import NewsStore from '@/modules/news/store';
import PatchNotesStore from '@/modules/patchnotes/store';
import MarketingMaterialsStore from '@/modules/marketing_materials/store';
import SoftwareLicensesModule from '@/modules/software-licenses/store';
import AnalyticsStore from '@/modules/analytics/store';
import GlobalSearchStore from '@/modules/global-search/store';
import ConferencesStore from '@/modules/conferences/store';
import PollsStore from '@/modules/polls/store';
import ContactsStore from '@/modules/contacts/store';
import RetroBonusesStore from '@/modules/retro-bonuses/store';
import CommercialOffersStore from '@/modules/commercial-offers/store';
import PartnerProductsStore from '@/modules/partner-products/store';
import EventsCalendarStore from '@/modules/events-calendar/store';
import PurchaseOrderStore from '@/modules/purchase-orders/store';
import DataPilotStore from '@/modules/data-pilot/store';
import AlfaApiLoanApplicationsStore from '@/modules/alfa-api-loan-applications/store';
import AlfaApiLoanApplicationStatusesStore from '@/modules/alfa-api-loan-application-statuses/store';

Vue.use(Vuex);

export const RootModule = new Module({
  modules: {
    auth: AuthModule,
    global: GlobalModule,
    user: UserModule,
    organizations: OrganizationsModule,
    shared_organizations: OrganizationsSharedModule,
    clients: ClientsModule,
    shared_clients: ClientsSharedModule,
    cart: CartModule,
    shared_cart: CartSharedModule,
    products: ProductsModule,
    orders: OrdersModule,
    staffs: StaffsModule,
    leads: LeadsModule,
    videos: VideosModule,
    subpartners: SubpartnersModule,
    companies_users: CompaniesUsersModule,
    repairs: RepairsStore,
    dispatches_store: DispatchesStore,
    notifications: NotificationsStore,
    last_notifications: LastNotificationsStore,
    widgets_store: WidgetsStore,
    marketing_fund: MarketingFund,
    repotrs: Reports,
    projects: ProjectsStore,
    brands: BrandsStore,
    courses_requests: CoursesRequestsStore,
    news: NewsStore,
    patch_notes: PatchNotesStore,
    marketing_materials: MarketingMaterialsStore,
    analytics: AnalyticsStore,
    software_licenses: SoftwareLicensesModule,
    global_search: GlobalSearchStore,
    conferences: ConferencesStore,
    polls: PollsStore,
    contacts: ContactsStore,
    retro_bonuses: RetroBonusesStore,
    commercial_offers: CommercialOffersStore,
    partner_products: PartnerProductsStore,
    calendar: EventsCalendarStore,
    purchase_orders: PurchaseOrderStore,
    data_pilot: DataPilotStore,
    alfa_api_loan_applications: AlfaApiLoanApplicationsStore,
    alfa_api_loan_application_statuses: AlfaApiLoanApplicationStatusesStore,
  },
});

export const store = createStore(RootModule);

const context = RootModule.context(store);

export const auth_store = context.modules.auth;
export const global_store = context.modules.global;
export const user_store = context.modules.user;
export const organizations_store = context.modules.organizations;
export const shared_organizations_store = context.modules.shared_organizations;
export const clients_store = context.modules.clients;
export const shared_clients_store = context.modules.shared_clients;
export const cart_store = context.modules.cart;
export const shared_cart_store = context.modules.shared_cart;
export const products_store = context.modules.products;
export const orders_store = context.modules.orders;
export const staffs_store = context.modules.staffs;
export const leads_store = context.modules.leads;
export const videos_store = context.modules.videos;
export const subpartners_store = context.modules.subpartners;
export const companies_users_store = context.modules.companies_users;
export const repairs_store = context.modules.repairs;
export const notifications_store = context.modules.notifications;
export const { dispatches_store } = context.modules;
export const { widgets_store } = context.modules;
export const { marketing_fund } = context.modules;
export const reports_store = context.modules.repotrs;
export const projects_store = context.modules.projects;
export const brands_store = context.modules.brands;
export const courses_requests_store = context.modules.courses_requests;
export const news_store = context.modules.news;
export const patch_notes_store = context.modules.patch_notes;
export const marketing_materials_store = context.modules.marketing_materials;
export const analytics_store = context.modules.analytics;
export const software_licenses_store = context.modules.software_licenses;
export const global_search_store = context.modules.global_search;
export const conferences_store = context.modules.conferences;
export const polls_store = context.modules.polls;
export const contacts_store = context.modules.contacts;
export const retro_bonuses_store = context.modules.retro_bonuses;
export const commercial_offers_store = context.modules.commercial_offers;
export const partner_products_store = context.modules.partner_products;
export const events_calendar_store = context.modules.calendar;
export const purchase_orders_store = context.modules.purchase_orders;
export const data_pilot_store = context.modules.data_pilot;
export const alfa_api_loan_applications_store = context.modules.alfa_api_loan_applications;
export const alfa_api_loan_application_statuses_store = context.modules.alfa_api_loan_application_statuses;
